export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;
export const AWS_URL = process.env.REACT_APP_AWS_URL;
export const AWS_MENU_URL = process.env.REACT_APP_MENU_URL;
